<pp-modal
  [ppNoHeader]="true"
  [ppNoFooter]="true"
  [ppWidth]="'375px'"
  [ppHeightVh]="80"
  [ppMaxHeight]="716"
  [ppCloseOnClickOutside]="!isEditing"
  [ppDisableScroll]="true"
  [ppReminderModal]="true"
  [ppNoPadding]="true"
>
  <ng-container body>
    @if (!isClosing) {
      @if (isEditing) {
        <div #body class="reminderModal__body">
          <section class="reminderModal__section">
            <span class="reminderModal__inputLabels">{{ 'reminder_name' | ppTranslate }}</span>
            <div class="inputContainer pointReminderModal__nameInput">
              <input
                required
                data-test="reminderNameInput"
                class="reminderModal__inputFields reminderModal__inputPadding"
                [placeholder]="'name' | ppTranslate"
                [(ngModel)]="nameInput"
                [attr.maxlength]="characterLimit"
                [class.pointReminderModal__nameInput--red]="nameInput().length == characterLimit"
                (focus)="isNameInputFocused = true"
                (blur)="isNameInputFocused = false"
              />
              <div
                class="characterLimit"
                [class.pointReminderModal__characterLimit--red]="
                  nameInput().length == characterLimit
                "
              >
                @if (isNameInputFocused) {
                  <span>{{ nameInput().length }} / {{ characterLimit }}</span>
                }
              </div>
            </div>
          </section>
          <section class="reminderModal__section">
            <span class="reminderModal__inputLabels">{{ 'description' | ppTranslate }}</span>
            <div class="inputContainer">
              <textarea
                rows="1"
                data-test="descriptionInput"
                class="reminderModal__inputFields reminderModal__inputPadding reminderModal__descriptionInput"
                [placeholder]="'add_a_description' | ppTranslate"
                [(ngModel)]="descriptionInput"
              ></textarea>
            </div>
          </section>
          <section class="reminderModal__section">
            <span class="reminderModal__inputLabels">{{ 'point' | ppTranslate }}</span>
            <pp-point-reminder-point-picker
              [ppReminder]="reminder"
              [ppNew]="isNew"
              [ppPointIdBackup]="pointIdBackup"
              (ppPointChange)="selectPoint($event)"
            ></pp-point-reminder-point-picker>
          </section>
          <section class="reminderModal__section">
            <span class="reminderModal__inputLabels">{{ 'create_for' | ppTranslate }}</span>

            <pp-point-reminder-modal-user-picker
              [ppAssignees]="reminder.assignees"
              (ppUsersChange)="setUsers($event)"
              [ppEditable]="true"
              [ppGuestUser]="pointPermission === EUserRole.LIMITED"
              [ppPointId]="reminder.pointId"
              [ppTargetUserId]="reminder.targetUserId"
            />
          </section>
          <div class="reminderModal__dateTimeFieldContainer">
            <div class="reminderModal__splitInputField">
              <span class="reminderModal__inputLabels">{{ 'date' | ppTranslate }}</span>
              <pp-datepicker
                data-test="dateSelect"
                class="reminderModal__inputFields no-border"
                [ppDate]="dateInput()"
                (ppSelect)="setDateInput($event)"
                [ppShowCalendarIcon]="true"
              ></pp-datepicker>
            </div>
            <div class="reminderModal__splitInputField">
              <span class="reminderModal__inputLabels">{{ 'time' | ppTranslate }}</span>
              <pp-point-reminder-modal-time-input [(ppTime)]="timeInput">
              </pp-point-reminder-modal-time-input>
            </div>
          </div>
          @if (isPastDate) {
            <span class="reminderModal__pastDateWarning"
              ><pp-icon [ppSrc]="EIconPath.ICON_BADGE_WARNING_14"></pp-icon
              >{{ 'selected_due_date_in_past_warning' | ppTranslate }}</span
            >
          }
          <pp-point-reminder-modal-recurring-options
            [(ppSeries)]="reminderSeries"
            [ppMinDate]="dateInput()"
            [ppDisabled]="reminderBackup?.seriesId && editingMode === EEditReminderOptions.SINGLE"
            (ppSeriesChange)="update()"
            (ppScrollToBottom)="onScrollToBottom()"
          ></pp-point-reminder-modal-recurring-options>
        </div>
      }
      @if (!isEditing) {
        <div class="reminderModal__body">
          <div class="reminderModal__closeIcon">
            <pp-icon
              [ppSrc]="EIconPath.ICON_CLOSE_24"
              ppColor="grey-600"
              class="saveIndicator__clear"
              ppClass="setSize24"
              (click)="close()"
            ></pp-icon>
          </div>
          <div class="reminderModal__container">
            <span class="reminderModal__viewName">{{ reminder.name }}</span>
            @if (reminder.description) {
              <span class="reminderModal__viewLabel">{{ 'description' | ppTranslate }}</span>
            }
            @if (reminder.description) {
              <span class="reminderModal__viewValue reminderModal__description">
                {{ reminder.description }}</span
              >
            }
            @if (reminder.pointId) {
              <span class="reminderModal__viewLabel">{{ 'point' | ppTranslate }}</span>
              <div class="reminderModal__viewPointContainer" (click)="viewPoint()">
                <div
                  class="reminderModal__priority"
                  [ngClass]="getPriorityClass(reminder.pointPriority)"
                >
                  {{ priorityName }}
                </div>
                <pp-icon [ppSrc]="statusIconSrc" ppClass="setSize14" ppColor="grey-500"></pp-icon>
                <span
                  class="reminderModal__pointTitle"
                  ppTooltip
                  [ppTitle]="reminder.pointTitle"
                  [ppTrimTooltip]="true"
                  >{{ reminder.pointTitle }}</span
                >
              </div>
            }
            @if (reminder.assignees?.length || !editable) {
              <div class="reminderModal__splitInputField">
                <span class="reminderModal__viewLabel">{{
                  (editable ? 'created_for' : 'created_by') | ppTranslate
                }}</span>

                <pp-point-reminder-modal-user-picker
                  [ppAssignees]="editable ? reminder.assignees : [reminder.targetUserId]"
                  [ppEditable]="false"
                  [ppTargetUserId]="reminder.targetUserId"
                />
              </div>
            }
            <div class="reminderModal__dateTimeFieldContainer">
              <div class="reminderModal__splitInputField">
                <span class="reminderModal__viewLabel">{{ 'date' | ppTranslate }}</span>
                <span class="reminderModal__viewValue">{{ date }}</span>
              </div>
              <div class="reminderModal__splitInputField">
                <span class="reminderModal__viewLabel">{{ 'time' | ppTranslate }}</span>
                <span class="reminderModal__viewValue">{{ time }}</span>
              </div>
            </div>
            <pp-point-reminder-modal-recurrence-display
              [ppSeries]="reminderSeries"
            ></pp-point-reminder-modal-recurrence-display>
            @if (isSnoozed) {
              <div class="reminderModal__snoozed">
                <span class="reminderModal__viewLabel">{{ 'snoozed' | ppTranslate }}</span>
                <div class="reminderModal__snooze">
                  <pp-icon
                    [ppSrc]="EIconPath.ICON_MISC_SNOOZE_18"
                    class="reminderSnoozeIcon"
                    ppClass="setSize18"
                    ppColor="inherit"
                  ></pp-icon>
                  <span>{{ reminderSnoozeTime }}</span>
                </div>
              </div>
            }
          </div>
        </div>
      }
      @if (isEditing) {
        <div
          class="reminderModal__actionButtonsRow reminderModal__actionButtonsPositioning reminderModal__actionButtons--border"
        >
          <pp-button
            class="reminderModal__actionButton"
            data-test="cancelReminderButton"
            ppStyle="secondary"
            ppSize="wide"
            (ppAction)="cancel()"
            >{{ 'cancel' | ppTranslate }}</pp-button
          >
          <pp-button
            data-test="setReminderButton"
            class="reminderModal__actionButton"
            (ppAction)="submit()"
            ppStyle="primary"
            ppSize="wide"
            [ppDisabled]="!nameInput().trim() || !isEdited || !timeInput()"
            >{{ isNew ? ('set_reminder' | ppTranslate) : ('save' | ppTranslate) }}</pp-button
          >
        </div>
      }
      @if (!isEditing) {
        <div
          class="reminderModal__actionButtons reminderModal__actionButtonsPositioning reminderModal__actionButtons--border"
        >
          <div class="reminderModal__actionButtonsRow">
            @if (editable) {
              <pp-point-reminder-modal-edit-reminder-button
                [ppIsSeries]="!!reminderSeries.frequency"
                (ppEditReminder)="toggleEdit($event)"
              ></pp-point-reminder-modal-edit-reminder-button>
            }
            <pp-button
              data-test="dismissReminderButton"
              class="reminderModal__actionButton"
              (ppAction)="dismiss()"
              ppStyle="primary"
              ppSize="wide"
              [ppDisabled]="reminder.dismissed"
              >{{ 'dismiss' | ppTranslate }}</pp-button
            >
          </div>
          <button
            class="reminderModal__delete"
            (click)="delete()"
            ppStyle="text"
            data-test="deleteReminderButton"
          >
            <pp-icon [ppSrc]="EIconPath.ICON_BIN_14" ppClass="setSize14" ppColor="red"></pp-icon
            >{{ 'Delete' | ppTranslate }}
          </button>
        </div>
      }
    } @else {
      <div
        class="reminderModal__closeWarningBody"
        [class.reminderModal__closeWarningBody--deleting]="isDeleting && reminderSeries.frequency"
      >
        <div class="reminderModal__contentPadding">
          @if (!(isDeleting && reminderSeries.frequency)) {
            <div class="reminderModal__cancelConfirmTextContainer">
              <p class="reminderModal__confirmCancelHeader">
                {{
                  isDeleting
                    ? ('delete_reminder_confirm' | ppTranslate)
                    : ('unsaved_changes' | ppTranslate)
                }}
              </p>
              <p class="reminderModal__confirmCancelMessage">
                {{
                  isDeleting
                    ? ('delete_reminder_message' | ppTranslate)
                    : ('unsaved_changes_message' | ppTranslate)
                }}
              </p>
            </div>
          }
          @if (isDeleting && reminderSeries.frequency) {
            <pp-reminder-delete-options
              [(ppReminderDeleteOption)]="reminderDeleteOption"
              (ppCancel)="toggleIsClosing()"
              [ppReminderId]="reminder.reminderId"
              [ppSeriesId]="reminderSeries.id"
              [ppCreatedForMe]="!editable"
            ></pp-reminder-delete-options>
          }
        </div>
        @if (!isDeleting) {
          <div class="reminderModal__actionButtonsRow reminderModal__actionButtonsPositioning">
            <pp-button
              class="reminderModal__actionButton"
              data-test="cancelReminderButton"
              ppStyle="secondary"
              ppSize="wide"
              (ppAction)="discardChanges()"
              [ppWarning]="true"
              >{{ 'discard_changes' | ppTranslate }}</pp-button
            >
            <pp-button
              data-test="setReminderButton"
              class="reminderModal__actionButton"
              (ppAction)="toggleIsClosing()"
              ppStyle="primary"
              ppSize="wide"
              >{{ 'continue_editing' | ppTranslate }}</pp-button
            >
          </div>
        }
        @if (isDeleting && !reminderSeries.frequency) {
          <div class="reminderModal__actionButtonsRow reminderModal__actionButtonsPositioning">
            <pp-button
              class="reminderModal__actionButton"
              data-test="cancelReminderButton"
              ppStyle="secondary"
              ppSize="wide"
              (ppAction)="toggleIsClosing()"
              >{{ 'cancel' | ppTranslate }}</pp-button
            >
            <pp-button
              data-test="setReminderButton"
              class="reminderModal__actionButton"
              (ppAction)="deleteConfirm()"
              ppStyle="primary"
              ppSize="wide"
              [ppWarning]="true"
              >{{ 'Delete' | ppTranslate }}</pp-button
            >
          </div>
        }
      </div>
    }
  </ng-container>
</pp-modal>
